import React from 'react';
import Form from 'react-bootstrap/Form';
import './Checkbox.css'

interface Props {
  checkboxId?: string;
  isChecked: boolean;
  labelMessage?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  children?: React.ReactNode;
  isInvalid?: boolean;
  errorMessage?: string;
  required?: boolean;
}


const Checkbox = (props: Props) => {
  
  return (
    <div className="checkbox-wrapper px-0">
      <Form.Check
        id={props.checkboxId}
        checked={props.isChecked}
        onChange={props.onChange}
        label={props.labelMessage}
        className={`${props.isInvalid ? 'check-error' : ''} ${props.required ? 'fieldRequired' : ''}`}
      />
      {props.children}
      <div className={`${props.required ? "requiredPlaceholder mb-3 px-0 pb-2" : ""}`}>
        {props.isInvalid && (
            <p className="validation-error px-0 my-0">
              {props.errorMessage}
            </p>
        )}
      </div>
    </div>
  )
}

export default Checkbox;
